"use strict";
// ATTENTION: DO NOT ADD REQUIRED() FLAG TO CLAIM SCHEMA
// Required fields are enforced at the end of claim-schema.ts `const submittedClaimSchema = claimSchema.options({ presence: 'required' });`
// This will ensure that all fields not explicitly marked as optional() are required
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowerSchema = void 0;
var claim_domain_1 = require("@hobt/claim-domain");
var constants_1 = require("@hobt/constants");
var utils_1 = require("@hobt/utils");
var Joi = require('joi').extend(require('@joi/date'));
exports.borrowerSchema = Joi.object({
    birthDate: Joi.date()
        .less(utils_1.getCurrentDate())
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, 'Birth Date'),
    }),
    claimBorrowerCategoryID: (_a = Joi.number()
        .integer()).valid.apply(_a, Object.values(claim_domain_1.ClaimBorrowerCategory)).options({ convert: false }),
    claimBorrowerTypeID: (_b = Joi.number()
        .integer()).valid.apply(_b, Object.values(claim_domain_1.ClaimBorrowerType)).options({ convert: false }),
    defaultReason: (_c = Joi.number()
        .integer()).valid.apply(_c, Object.values(claim_domain_1.DefaultReason)).options({ convert: false }),
    financialAssessmentCompleted: Joi.boolean(),
    firstName: Joi.string()
        .min(1)
        .max(15),
    informationSentToNationalRecoveriesCenterDate: Joi.date()
        .optional()
        .allow(''),
    judgmentAction: (_d = Joi.string()).valid.apply(_d, Object.values(claim_domain_1.JudgmentAction)),
    judgmentBankruptcyInformationReceivedDate: Joi.date()
        .optional()
        .allow(''),
    lastName: Joi.string()
        .min(1)
        .max(25),
    otherDefaultReason: Joi.string()
        .min(1)
        .max(100)
        .optional()
        .when('defaultReason', {
        is: claim_domain_1.DefaultReason.Other,
        then: Joi.required(),
        otherwise: Joi.valid(null, ''),
    }),
    otherReasonNotPursued: Joi.string()
        .min(1)
        .max(100)
        .optional()
        .when('reasonNotPursued', {
        is: claim_domain_1.ReasonNotPursued.Other,
        then: Joi.required(),
        otherwise: Joi.valid(null, ''),
    }),
    reasonNotPursued: Joi.number()
        .integer()
        .optional()
        .when('judgmentAction', {
        is: claim_domain_1.JudgmentAction.NotPursued,
        then: (_e = Joi.required()).valid.apply(_e, Object.values(claim_domain_1.ReasonNotPursued)).options({ convert: false }),
        otherwise: Joi.valid(null, ''),
    }),
});
